import { useEffect, useState, createContext, useContext } from "react";
import { api } from "./api";

const SettingsCtx = createContext({ settings: null, refresh: () => {} });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  const refresh = async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
      if (data?.primary_color) {
        document.documentElement.style.setProperty("--brand-navy", data.primary_color);
      }
      if (data?.secondary_color) {
        document.documentElement.style.setProperty("--brand-sky", data.secondary_color);
      }
      if (data?.accent_color) {
        document.documentElement.style.setProperty("--brand-red", data.accent_color);
      }
    } catch (e) {
      console.warn("settings load failed", e);
    }
  };

  useEffect(() => { refresh(); }, []);
  return <SettingsCtx.Provider value={{ settings, refresh }}>{children}</SettingsCtx.Provider>;
};

export const useSettings = () => useContext(SettingsCtx);

export function isOpenNow(hours = []) {
  // Always returns a POSITIVE message — never "Fermé" standalone.
  const DAYS = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];
  const now = new Date();
  const todayIdx = (now.getDay() + 6) % 7; // Monday=0
  const mins = now.getHours() * 60 + now.getMinutes();

  const parseHM = (t) => {
    if (!t) return null;
    const [h, m] = t.split(":").map(Number);
    if (Number.isNaN(h)) return null;
    return h * 60 + (m || 0);
  };
  const slots = (dayData) => {
    if (!dayData || dayData.closed) return [];
    const out = [];
    for (const key of ["morning", "afternoon"]) {
      const range = dayData[key];
      if (!range) continue;
      const [a, b] = range.split("-").map((s) => s.trim());
      const sa = parseHM(a); const sb = parseHM(b);
      if (sa != null && sb != null && sb > sa) out.push({ start: sa, end: sb, label: a });
    }
    return out.sort((x, y) => x.start - y.start);
  };
  const fmt = (m) => {
    const h = Math.floor(m / 60); const mm = m % 60;
    return mm ? `${h}h${String(mm).padStart(2, "0")}` : `${h}h`;
  };

  // 1) Open right now ?
  const todaySlots = slots(hours[todayIdx]);
  for (const s of todaySlots) {
    if (mins >= s.start && mins <= s.end) return { open: true, label: "Ouvert maintenant" };
  }

  // 2) Later today ?
  const laterToday = todaySlots.find((s) => s.start > mins);
  if (laterToday) return { open: false, label: `Ouvre à ${fmt(laterToday.start)}` };

  // 3) Next open day (search 1..7 ahead)
  for (let i = 1; i <= 7; i++) {
    const idx = (todayIdx + i) % 7;
    const next = slots(hours[idx]);
    if (!next.length) continue;
    const dayLabel = i === 1 ? "demain" : DAYS[idx].toLowerCase();
    return { open: false, label: `Ouvre ${dayLabel} à ${fmt(next[0].start)}` };
  }

  // 4) Fallback — no hours configured
  return { open: false, label: "Sur rendez-vous" };
}
